export default __webpack_public_path__ + "static/media/miguel-lopes-9.26472b30.jpg";